import { v4 as uuid } from "uuid";
import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";

import { open, close, setPos } from '@/reducers/Window'
import { XCircleIcon } from '@heroicons/react/20/solid'

import { BarsArrowUpIcon, UsersIcon, MagnifyingGlassIcon } from '@heroicons/react/16/solid'
import { TablePagination } from "@/components/holders/TablePagination";
import DB from "@/models/DB";

import { SelectBox } from "@/components/holders/SelectBox";
import {AddButton} from '@/views/base/Buttons/AddButton'


export function TimeRegistrationWindowView({...props})  {
    
    const searchField = useRef(null);
    const [searchTxt, setSearchTxt] = useState(props?.searchTxt);
    const [customers, setCustomers] = useState([]);
    const [tableItems, setTableItems] = useState(props.invoiceRow.timeregistrations);
    const [worktype, setWorktype] = useState();
    const [updateKey, setUpdateKey] = useState( uuid().slice(0, 8) ); 
useEffect(() => {
    if(!worktype) {
        const state = store.getState();
        const {InvoiceReducer} = state;
        const {workTypes} = InvoiceReducer;
        
        setWorktype(workTypes);
        //props.invoiceRow.timeregistrations = props.data; //DB.newCollection(props?.data);
        //setTableItems(props.invoiceRow.timeregistrations);
    }
    return () => {
    };
  }, [worktype, setWorktype, props]);

useEffect(() => {
    return () => {
    };
  }, [props]);

  const setItemCheck = (item, index) => {
    
    item.selected = !item.selected;
    return;
    let newData = [...tableItems];
    let currentItem = newData[index];
    if(typeof currentItem?.check === 'boolean' ) {
        currentItem.check = !currentItem.check;
    } else {
        currentItem = {...currentItem, check: false}
    }
    newData[index] = currentItem;
    
    let regitem = props.invoiceRow.timeregistrations.findChildByKey(currentItem.key, 'key');
    regitem.check = currentItem.check;
    
    //setTableItems(newData);
  }
  
  const setWorktypeByCombo=(selectedItem, item) => {
    let regitem =item; // props.invoiceRow.timeregistrations.findChildByKey(item.key, 'key');
    
    regitem.worktype_key = selectedItem.key;
    regitem.price = selectedItem.price;
    
    
    
    console.debug( props.invoiceRow.timeregistrations ) ;
    
    setTableItems(props.invoiceRow.timeregistrations);
    setUpdateKey(uuid().slice(0, 8));
  }
  
  const saveHandler = (event) => {
    
    

        
        if(props?.window?.onCloseHandler) {
            props?.window?.onCloseHandler(props.invoiceRow);
        }
        
        store.dispatch( close(props.window) );
        return false;
    
    
  }
  
    const getCustomersDossierEvent=(customer) => {
        if(props.getCustomersDossierHandler) {
            props.getCustomersDossierHandler(customer);
        }
        
    }

    const openDossierEvent=(dossier) => {
        if(props.openDossierEventHandler) {
            props.openDossierEventHandler(dossier);
        }
        
    }
    const onkeydownEvent = (event) => {
        
        if(event.keyCode === 13) {
            event.preventDefault();
            searchEventHandler(event);
        }
        
        return false;
    }
    const searchEventHandler = (event) => {
        if(props.onSearchEventHandler) {
            setSearchTxt(searchField.current.value);
            props.onSearchEventHandler(event, searchField.current.value);
        }
        
        return false;
    }
    let vis = false;
       return (
           <>
 {vis &&
           <div className="grid grid-cols-12 gap-2">
    <div className="col-span-5">


   <div className="pb-2 ">
    
      <div className="mt-2 flex">
        <div className="-mr-px grid grow grid-cols-1 ">
          <input
            ref={searchField}
            autoFocus
            id="query"
            name="query"
            type="text"
            defaultValue={searchTxt}
            placeholder="Klant of dossier naam"
            data-dashlane-disabled-on-field="true"
            onKeyDown={(event) => onkeydownEvent(event)}
            key={"serachBox"}
            className="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pl-9 sm:text-sm/6"
          />
          <MagnifyingGlassIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
          />
          
      </div>
<button
    onClick={searchEventHandler}
          type="button"
          className="flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
        >
          Zoeken
        </button>          
        </div>
        </div>
    
    
        <div className="">
        </div>
        
    </div>
      </div>
}
    <div className="col-span-7 h-full min-h-0 flex-col">

                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                          &nbsp;
                        </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Dossier
                      </th>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                        Organisatie sector<br/>
                        Afdeling
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Tijd & Registratie datum
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Type werk
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                        <span className="sr-only">Factureren</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {tableItems && tableItems.map((item, index) => (
                      <tr key={uuid().slice(0, 8)}>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <input key={uuid().slice(0, 8)} type="checkbox" defaultChecked={item.selected} onChange={(event => setItemCheck(item, index))}/>
                        </td>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                            <div className="gap-x-6">
                                {item?.dossier_key && item.dossier_key.customer &&  
                                    <span className="block">{item.dossier_key.customer.name}</span>
                                }
                                {item?.dossier_key && 
                                    <span className="block">{item.dossier_key.name}</span>
                                }
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <h3 className="mt-2 text-sm font-semibold text-gray-900">{item.sector.name}</h3><span>{item.department.name}</span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <h3 className="mt-2 text-sm font-semibold text-gray-900">{item.hours} uur - {item.minutes} minuten</h3><span>{item.worklog_date}</span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <>
                            { item?.worktype && item?.worktype?.name &&
                            <h3 className="mt-2 text-sm font-semibold text-gray-900">{(item?.worktype?.name) ? item.worktype.name : "Onbekend"}</h3>
                            }
                            <AddButton key={item?.worktype_key} data={worktype} selected={item?.worktype_key} label={(item) => {return item.name+"  "+item.price}} placeHolder="Selecteer het soort werk" changeEvent={(selectedData) => setWorktypeByCombo(selectedData, item)}/>
                            </>
                        </td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">
                        <>
                          
                          </>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
    
        
        
          
    </div>
    
    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse absolute bottom-20">
      <button
        type="button"
        onClick={() => saveHandler(event)}
        className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
      >
        Opslaan
      </button>
      <button
        type="button"
        //data-autofocus
        //onClick={() => setOpen(false)}
        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
      >
        Annuleer
      </button>
    </div>
    
    
    </>
    );
}